export default __webpack_public_path__ + "static/media/cancelAccount.4f4db78c.png";